export enum InfluencerUpgradeFormEnum {
  ENABLE_ACCESS_ADD_CREDITS = "yes",
  NO_ACCESS_NEEDED = "no",
}
